import { render, staticRenderFns } from "./changepass.vue?vue&type=template&id=4ae8edb1&"
import script from "./changepass.vue?vue&type=script&lang=js&"
export * from "./changepass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports